module.exports = __webpack_public_path__ + "static/media/Completed.57e5c2be.png";